<template>
  <div id="scroll-top">
    <spacer :y="5"/>
    <ul>

      <stack-item>
        <contents-box title="検索">
          <form v-on:submit="registKeyword">
            <div :class="$style.wordsearch">
              <div :class="$style.wordsearch_form">
                <word-search-form
                  placeholder="名前・フリガナ・IDで検索"
                  v-on:sendValue="receiveValue" />
              </div>
              <i
                :class="$style.wordsearch_btn"
                class="fa-regular fa-magnifying-glass"
                v-on:click="registKeyword"/>
            </div>
          </form>
          <spacer :y="2" />
          <div :class="$style.select">
            <dl>
              <dt>学校ソート</dt>
              <dd>
                <select
                  :class="[$style.select_box, $style.school]"
                  v-model="searchCondition.clientSchool">
                  <option :value="null">指定なし</option>
                  <option
                    v-for="n of clientSchools"
                    :key="n.id"
                    :value="n.id">{{ n.name }}</option>
                </select>
              </dd>
            </dl>
          </div>
          <spacer :y="2" />
          <div>
            <ul :class="$style.select">
              <li v-for="item of activeTypeItems" :key="item.name">
                <input
                  type="checkbox"
                  :id="item.name"
                  :value="item.value"
                  v-model="item.checked">
                <label :for="item.name">{{ item.label }}</label>
                <GuideIcon
                  v-if="item.help"
                  icon='fa-regular fa-circle-question'
                  boxSize='330'
                  :hoverText="item.help"
                  noTransform="true"
                />
              </li>
            </ul>
          </div>
        </contents-box>
      </stack-item>

      <stack-item v-if="this.page === 1 && flag.showArea.progress">
        <contents-box title="受付中（未回答）">
          <loader-simple :flag="flag.loaders.progress">
            <ul v-if="user.counseling.counselor.text.progress.length">
              <stack-item
                v-for="(row, i) of user.counseling.counselor.text.progress"
                :key="row.id"
                v-show="row.messages.length === 1">
                <user-box
                  :showCocomoniBtn="true"
                  :ownUser="user"
                  :bg="userBoxColor(row.customer)"
                  :user="row.customer"
                  :showId="true"
                  :link="`/counselor/history/user/${row.customer.id}`"
                  :targetBlank="true"
                  :enableCounselorMessage="true"
                  :isMyCustomer="isMyCustomer(row.customer.id)">
                  <template v-slot:main>
                    <spacer :y="4"/>
                    <counseling-base
                      :data="row"
                      :showProgressReserve="true" />

                    <spacer :y="3"/>
                    <hr>
                    <spacer :y="3" />
                    <div>
                      <textarea
                        name="answer"
                        id="answer"
                        rows="8"
                        v-model="counselorMessages[row.id]"
                        :class="$style.textarea"></textarea>

                      <div :class="$style.count">
                        <p v-if="row.answer && row.answer.length">{{ row.answer.length }}/<span>600</span></p>
                      </div>
                    </div>

                    <spacer :y="3"/>
                    <div>
                      <btn-container>
                        <basic-btn
                          tag="button"
                          :class="$style.btn"
                          v-on:click="submit($event, i, 'progress', 1)">回答</basic-btn>
                        <spacer :x="2"/>
                        <basic-btn
                          tag="button"
                          :class="$style.btn"
                          v-on:click="submit($event, i, 'progress', 2)">下書き保存</basic-btn>
                        <spacer :x="2"/>
                      </btn-container>

                      <user-watch-btn
                        :customer="row.customer"
                        :counseling_type="CONSTANTS.COUNSELING_TYPE_TEXT"
                        :counseling_data="row"
                        @update-user-watch-data="afterUpdateUserWatchData"
                      />

                      <risk-application-btn
                        :counseling_type="CONSTANTS.COUNSELING_TYPE_TEXT"
                        :foreign_id="row.id"
                        :target_user_id="row.user_id"
                      />

                    </div>
                  </template>
                </user-box>
              </stack-item>
            </ul>

            <p v-else-if="!flag.loaders.progress">ただいま未回答中のテキスト健康相談はありません。</p>
          </loader-simple>
        </contents-box>
      </stack-item>


      <stack-item v-if="this.page === 1 && flag.showArea.draft">
        <contents-box title="下書き保存">
          <loader-simple :flag="flag.loaders.draft">
            <ul v-if="user.counseling.counselor.text.draft.length">
              <stack-item
                v-for="(row, i) of user.counseling.counselor.text.draft"
                :key="row.id">
                <user-box
                  :showCocomoniBtn="true"
                  :ownUser="user"
                  :user="row.customer"
                  :bg="userBoxColor(row.customer)"
                  :showId="true"
                  :link="`/counselor/history/user/${row.customer.id}`"
                  :targetBlank="true"
                  :enableCounselorMessage="true"
                  :isMyCustomer="isMyCustomer(row.customer.id)">
                  <template v-slot:main>
                    <spacer :y="4"/>
                    <counseling-base
                      :data="row"
                      :showProgressReserve="true" />

                    <spacer :y="3"/>
                    <hr>
                    <spacer :y="3" />
                    <div>
                      <p>回答者：{{ row.messages[1].user.username }}</p>
                      <spacer :y="1" />
                      <textarea
                        name="answer"
                        id="answer"
                        rows="8"
                        v-model="counselorMessages[row.id]"
                        :class="$style.textarea"
                        :disabled="row.messages[1].user.id !== user.id"></textarea>

                      <div :class="$style.count">
                        <p v-if="row.answer && row.answer.length">{{ row.answer.length }}/<span>600</span></p>
                      </div>
                    </div>

                    <spacer :y="3"/>
                    <div>
                      <btn-container>
                        <basic-btn
                          tag="button"
                          :class="$style.btn"
                          v-on:click="submit($event, i, 'draft', 1)"
                          :disabled="row.messages[1].user.id !== user.id">回答</basic-btn>
                        <spacer :x="2"/>
                        <basic-btn
                          tag="button"
                          :class="$style.btn"
                          v-on:click="submit($event, i, 'draft', 2)"
                          :disabled="row.messages[1].user.id !== user.id">下書き保存</basic-btn>
                        <spacer :x="2"/>
                      </btn-container>


                      <user-watch-btn
                        :customer="row.customer"
                        :counseling_type="CONSTANTS.COUNSELING_TYPE_TEXT"
                        :counseling_data="row"
                        @update-user-watch-data="afterUpdateUserWatchData"
                      />

                      <risk-application-btn
                        :counseling_type="CONSTANTS.COUNSELING_TYPE_TEXT"
                        :foreign_id="row.id"
                        :target_user_id="row.user_id"
                      />

                    </div>
                  </template>
                </user-box>
              </stack-item>
            </ul>

            <p v-else-if="!flag.loaders.draft">ただいま下書き保存中のテキスト健康相談はありません。</p>
          </loader-simple>
        </contents-box>
      </stack-item>


      <stack-item>
        <contents-box title="実施済み">
          <pagination
            v-if="!flag.loaders.answered && pageMax && pageMax !== 1"
            :page="page"
            :pageMax="pageMax"
            :path="'/counselor/?tab=text'" />
          <spacer :y="4"/>

          <loader-simple :flag="flag.loaders.answered">
            <ul
              v-if="!flag.loaders.answered
                && user.counseling.counselor.text.answered[page]
                && user.counseling.counselor.text.answered[page].length">
              <stack-item
                v-for="row of user.counseling.counselor.text.answered[page]"
                :key="row.id">
                <user-box
                  :showCocomoniBtn="true"
                  :ownUser="user"
                  :user="row.customer"
                  :bg="userBoxColor(row.customer)"
                  :showId="true"
                  :link="`/counselor/history/user/${row.customer.id}`"
                  :targetBlank="true"
                  :enableCounselorMessage="true"
                  :isMyCustomer="isMyCustomer(row.customer.id)">
                  <template v-slot:main>
                    <spacer :y="4"/>
                    <counseling-base
                      :data="row"
                      :showProgressReserve="true" />

                    <spacer :y="4" />
                    <user-box
                      type="inner"
                      :showId="false"
                      v-if="row.messages[1] && row.messages[1].user"
                      :showAge="false"
                      :user="row.messages[1].user">
                      <template v-slot:btn>
                        <div :class="$style.open" v-on:click="handleShowAnswer(row.id)">
                          <p :class="$style.open_p">{{ row.showBottom ? '回答をしまう' : '回答をみる'}}</p>
                          <i v-if="!showAnswers[row.id]" :class="$style.icon" class="fa-regular fa-angles-down"></i>
                          <i v-if="showAnswers[row.id]" :class="$style.icon" class="fa-regular fa-angles-up"></i>
                        </div>
                      </template>
                      <template v-slot:main>
                        <div v-if="showAnswers[row.id]">
                          <spacer :y="2"/>
                          <div class="n2br" :class="$style.answer">
                            <p v-html="row.messages[1].message"></p>
                          </div>
                        </div>
                      </template>
                    </user-box>

                    <user-watch-btn
                      :customer="row.customer"
                      :counseling_type="CONSTANTS.COUNSELING_TYPE_TEXT"
                      :counseling_data="row"
                      @update-user-watch-data="afterUpdateUserWatchData"
                    />

                    <risk-application-btn
                      :counseling_type="CONSTANTS.COUNSELING_TYPE_TEXT"
                      :foreign_id="row.id"
                      :target_user_id="row.user_id"
                    />

                  </template>
                </user-box>
              </stack-item>
            </ul>
            <spacer :y="4" />
            <spacer v-if="flag.loaders.answered" :y="6" />

            <pagination
              v-if="!flag.loaders.answered && pageMax && pageMax !== 1"
              :page="page"
              :pageMax="pageMax"
              :path="'/counselor/?tab=text'" />

            <p
              v-else-if="!flag.loaders.answered
                && user.counseling.counselor.text.answered[page]
                && !user.counseling.counselor.text.answered[page].length">実施済みのテキスト健康相談はありません。</p>
          </loader-simple>
        </contents-box>
      </stack-item>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StackItem from '@/views/components/StackItem.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import UserBox from '@/views/components/UserBox.vue';
import Spacer from '@/views/components/Spacer.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import { CounselingBase } from '@/views/components/parts/Counseling/';
import Pagination from '@/views/components/Pagination.vue';
import RiskApplicationBtn from '@/views/pages/Counselor/parts/RiskApplicationBtn.vue';
import WordSearchForm from '@/views/components/WordSearchForm.vue';
import UserWatchBtn from '@/views/pages/Counselor/parts/UserWatchBtn.vue';
import GuideIcon from '@/views/components/GuideIcon.vue';

import cf from '@/mixins/commonFunctions';

export default {
  name: 'counselor-text-counseling',
  mixins: [cf],
  components: {
    BtnContainer,
    BasicBtn,
    StackItem,
    ContentsBox,
    UserBox,
    Spacer,
    LoaderSimple,
    CounselingBase,
    Pagination,
    RiskApplicationBtn,
    WordSearchForm,
    UserWatchBtn,
    GuideIcon,
  },
  data() {
    return {
      flag: {
        runInterval: false,
        alert: false,
        loaders: {
          progress: true,
          draft: true,
          answered: true,
        },
        showArea: {
          answered: true, // 常時表示
          draft: true,
          progress: true,
        },
      },
      page: 1,
      pageMax: 1,
      // limit: 10,
      limit: 5,
      counselorMessages: {},
      showAnswers: {},
      CONSTANTS: { // 定数
        COUNSELING_TYPE_TEXT: '2', // テキスト健康相談タイプ
      },
      searchCondition: {
        keyword: null,
        targetColumn: [],
        clientSchool: null, // クライアントの所属学校
      },
      clientSchools: [], // 今までに担当したクライアントの所属学校データ
      activeTypeItems: [ // チェックボックスで表現する検索条件
        {
          name: 'isWatched',
          label: '２週間アラート設定中の利用者',
          value: 1,
          checked: false,
        },
        {
          name: 'onlyMyClient',
          label: '担当最終相談（実施済み）',
          value: 1,
          checked: false,
          help: 'テキスト・オンラインに関わらず最終の健康相談を対応した利用者の情報を検索表示します。\n医師・心理士は対象の利用者に対し、「２週間アラート」の設定や、該当利用者に対して「先生からのメッセージ」を送ることができます。',
        },
        // {
        //   name: 'onlyLatestByUser',
        //   label: '実施済み: 最新のみ表示',
        //   value: 1,
        //   checked: false,
        // },
      ],
      myWatchedClients: [],
    };
  },
  created() {
    // ストアのカウンセラー用データをクリア
    this.$store.commit('user/counseling/clearCounselorDatas');

    // 今までに担当したクライアントの所属学校データを取得
    this.getClientSchools();

    if (this.$route.query.tab !== 'text') return;
    const query = this.$route.query;
    if (query.page) {
      this.page = Number(query.page);
    } else if (query.tab === 'text') {
      // queryにpageがなければ追加してreplace
      this.$router.replace('/counselor/?tab=text&page=1');
      return;
    }
    this.getTypeTexts();
  },
  watch: {
    $route() {
      if (this.$route.query.tab !== 'text') return;
      this.flag.loaders = { progress: true, draft: true, answered: true };

      const query = this.$route.query;
      if (query.page) {
        this.page = Number(query.page);
      } else if (query.tab === 'text') { // queryにpageがなければ追加してreplace
        this.$router.replace('/counselor/?tab=text&page=1');
        return;
      }

      if (!this.user.counseling.counselor.text.progress.length
        && !this.user.counseling.counselor.text.draft.length
        && !this.user.counseling.counselor.text.answered[1].length) {
        // 全てデータがない（ホーム等別ページから遷移してきた）場合は全取得
        this.getTypeTexts();
      } else if (!this.user.counseling.counselor.text.answered[this.page]
        || (this.user.counseling.counselor.text.answered[this.page]
          && !this.user.counseling.counselor.text.answered[this.page].length)) {
        // 実施済みの指定ページにデータがなければ取得
        this.flag.loaders.progress = false;
        this.flag.loaders.draft = false;
        this.getTypeText('answered');
      } else {
        this.flag.loaders.progress = false;
        this.flag.loaders.draft = false;
        this.flag.loaders.answered = false;
      }

    },
  },
  computed: {
    ...mapState(['user', 'helper']),
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /**
     * テキスト健康相談データをtypeごとに取得
     */
    async getTypeTexts() {
      if (!this.user.manageWeekdays.length) return;

      // 自分が最終相談者になっている相談者データを取得
      await this.getMyWatchedClients();

      const types = ['progress', 'draft', 'answered'];
      types.forEach((type) => {

        // 表示エリアの制御
        if (type !== 'answered') { // 「実施済み」は常時表示、そのほかは条件によって表示/非表示
          this.flag.showArea[type] = this.isOnlyMyClient() === 0;
        }

        if (this.page > 1 && (type === 'progress' || type === 'draft')) {
          // this.datas[type] = [];
        } else if (!this.flag.showArea[type]) {
          // 非表示エリアに対するデータ取得は省略する
        } else {
          const limit = type === 'answered' ? this.limit : 999999;
          const params = {
            orderBy: type === 'answered' ? 'desc' : 'asc',
            weekdays: this.user.manageWeekdays,
            includeDraft: type === 'draft' ? 1 : 0,
            target_type: 1,
            page: type === 'answered' ? this.page : 1,
            isRisk: 1,
            limit,
            type,
            targetColumn: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.targetColumn : null,
            keyword: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.keyword : null,
            school_id: this.searchCondition.clientSchool ? this.searchCondition.clientSchool : null, // クライアントの所属学校
            only_watched_user: this.isOnlyWatchedUser(),
            isUserWatch: 1,
            only_my_client_data: this.isOnlyMyClient(),
            only_my_client_counselor_id: this.isOnlyMyClient() ? this.user.id : null,
            only_latest_by_user: type === 'answered' ? this.isOnlyWatchedUser() || this.isOnlyMyClient() : null, // 実施済みの場合のみパラメータ追加
          };

          this.axios({
            method: 'GET',
            url: '/v2/messageGroup/get/typeList',
            params,
          })
            .then(async (response) => {
              const groups = response.data.groups;
              const commitData = {
                type: 'text',
                division: type,
                values: groups.data,
              };
              // 「実施済み」のみページネーション
              if (type === 'answered') commitData.page = this.page;
              // それぞれのstoreへデータを登録
              this.$store.commit('user/counseling/putCounselorDatas', commitData);

              if (type === 'answered') {
                // 「実施済み」のみページネーション用の仕込み・[回答をみる]のフラグ追加
                this.pageMax = groups.lastPage;
                this.putShowAnsweres(groups.data);
              } else {
                // 「受付中」「下書き」は該当するmodelデータを作成
                this.putCounselorMessages(groups.data);
              }
            })
            .catch((error) => {
              if (error.response) console.log(error.response.data);
              else console.log(error);
            })
            .finally(() => {
              this.flag.loaders[type] = false;
            });
        }
      });
    },

    /**
     * テキスト健康相談データ typeを指定して取得
     */
    async getTypeText(type) {
      if (!this.user.manageWeekdays.length) return;
      const types = ['progress', 'draft', 'answered'];
      if (!types.includes(type)) return;

      // 自分が最終相談者になっている相談者データを取得
      await this.getMyWatchedClients();

      const limit = type === 'answered' ? this.limit : 999999;
      const params = {
        orderBy: type === 'answered' ? 'desc' : 'asc',
        weekdays: this.user.manageWeekdays,
        includeDraft: type === 'draft' ? 1 : 0,
        target_type: 1,
        isRisk: 1,
        page: type === 'answered' ? this.page : 1,
        limit,
        type,
        targetColumn: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.targetColumn : null,
        keyword: this.searchCondition.keyword && this.searchCondition.keyword !== '' ? this.searchCondition.keyword : null,
        school_id: this.searchCondition.clientSchool ? this.searchCondition.clientSchool : null, // クライアントの所属学校
        only_watched_user: this.isOnlyWatchedUser(),
        only_my_client_data: this.isOnlyMyClient() ? 1 : 0,
        only_my_client_counselor_id: this.isOnlyMyClient() ? this.user.id : 0,
        only_latest_by_user: type === 'answered' ? this.isOnlyMyClient() : null, // 実施済みの場合のみパラメータ追加
      };

      // 表示エリアの制御
      if (type !== 'answered') { // 「実施済み」は常時表示、そのほかは条件によって表示/非表示
        this.flag.showArea[type] = this.isOnlyMyClient() === 0;
        // 非表示エリアに対するデータ取得は省略する
        if (!this.flag.showArea[type]) return;
      }

      this.axios({
        method: 'GET',
        url: '/v2/messageGroup/get/typeList',
        params,
      })
        .then(async (response) => {
          const groups = response.data.groups;
          const commitData = {
            type: 'text',
            division: type,
            values: groups.data,
          };
          // 「実施済み」のみページネーション
          if (type === 'answered') commitData.page = this.page;
          // それぞれのstoreへデータを登録
          this.$store.commit('user/counseling/putCounselorDatas', commitData);
          if (type === 'answered') {
            // 「実施済み」のみ[回答をみる]のフラグ追加
            this.putShowAnsweres(groups.data);
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.loaders[type] = false;
        });
    },

    checkDrafts() {
      this.datas.progress.forEach((row) => {
        const params = {
          id: row.id,
          includeDraft: 1,
        };

        this.axios({
          method: 'GET',
          url: '/v1/messageGroup/get/detail',
          params,
        })
          .then((response) => {
            const res = response.data;
            if (res.detail.messages.length === 2) {
              // alertが重複して出ないように
              if (!this.flag.alert) {
                this.flag.alert = true;
                alert('新たに回答が作成されたテキスト健康相談があります。\nリロードで情報を更新してください。');
              }
              this.flag.alert = false;
            }
          })
          .catch((error) => {
            if (error.message) console.log(error.message);
            else console.log(error);
          });
      });
    },

    // 入力する回答のモデル
    putCounselorMessages(data) {
      data.forEach((d) => {
        // 下書きの場合はlengthが2になるため[1].message
        // 利用者メッセージのみの場合はlengthが1なので空
        const counselorMessage = d.messages.length > 1 ? d.messages[1].message : '';
        this.counselorMessages[d.id] = counselorMessage;
      });
    },

    // 回答をみるフラグの初期値
    putShowAnsweres(data) {
      data.forEach((d) => {
        this.showAnswers[d.id] = false;
      });
    },

    // 回答をみるフラグのハンドリング
    handleShowAnswer(id) {
      const next = !this.showAnswers[id];
      this.showAnswers[id] = next;
    },

    /**
     * 回答・下書き保存
     */
    submit(e, index, type, flag) {
      e.preventDefault();
      let submitConfirm = true;
      if (flag === 1) submitConfirm = confirm('回答は取り消せません。よろしいですか？');
      if (!submitConfirm) return;

      this.showLoading();

      const target = this.user.counseling.counselor.text[type][index];
      // 登録時はnull
      const messageId = target.messages.length === 2
        ? target.messages[1].id
        : null;
      const data = {
        flag, // 1 => 回答, 2 => 下書き
        user_id: this.user.id,
        message: this.counselorMessages[target.id],
        group_id: target.id,
        message_id: messageId,
      };

      let action = '登録';
      if (flag === 2) action = '下書き保存';
      const method = !messageId ? 'register' : 'updater';

      if (method === 'register') this.checkDuplicateText(target, data, method, action, flag);
      else this.updateTexts(target, data, method, action, flag);
    },

    checkDuplicateText(target, data, method, action, flag) {
      const params = {
        id: target.id,
      };

      this.axios({
        method: 'GET',
        url: '/v2/messageGroup/get/liteDuplicateCheck',
        params,
      })
        .then((response) => {
          const res = response.data.result.data[0];
          if (res.flag !== 1) {
            const status = res.flag === 11 ? '回答' : '下書き';
            alert(`このテキスト健康相談はすでに${status}が登録されています。\nリロードして情報を更新してください。`);
            this.hideLoading();
          } else {
            this.updateTexts(target, data, method, action, flag);
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    updateTexts(target, data, method, action, flag) {
      this.axios({
        method: 'POST',
        url: `/v1/message/set/${method}`,
        data,
      })
        .then(() => {
          alert(`ありがとうございます。ご回答内容を${action}しました！`);
          // 描画初期化
          this.flag.loaders = { progress: true, draft: true, answered: true };
          // 表示用のstore初期化
          const types = ['progress', 'draft', 'answered'];
          types.forEach((type) => {
            const commitData = { type: 'text', division: type, values: [] };
            if (type === 'answered') commitData.page = 1;
            this.$store.commit('user/counseling/putCounselorDatas', commitData);
          });
          this.getTypeTexts();
          // 回答の場合はメール・LINE連絡
          if (flag === 1) this.textCounselingContact(target.id);
          else this.hideLoading();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },

    /** テキストカウンセリング回答の連絡 */
    textCounselingContact(groupId) {
      // 利用者へ連絡
      this.axios({
        method: 'POST',
        url: '/v1/contact/answer/text',
        data: { group_id: groupId },
      })
        .then((response) => {
          if (this.helper.env.name === 'local') {
            console.log(response.data);
          }
          this.hideLoading();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.hideLoading();
        });
    },

    receiveValue(data) {
      const userIdRegex = new RegExp(/^[0-9０-９]{4}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{1,}(-|ー|−|―|‐|-|ｰ)[0-9０-９]{4}$/);
      if (userIdRegex.test(data.value)) {
        const userId = data.value.split(/[-|ー|−|―|‐|-|ｰ]/);
        this.searchCondition.keyword = String(Number(cf.toHalfNumber(userId[2]))); // user.id指定
        this.searchCondition.targetColumn = ['id', 'old_id'];
      } else {
        this.searchCondition.keyword = data.value;
        this.searchCondition.targetColumn = ['username', 'kana', 'id', 'old_id'];
      }
    },

    // 検索実行
    registKeyword(e) {
      e.preventDefault();
      if (this.searchCondition.keyword === '') this.searchCondition.keyword = null;

      // 各種データ初期化
      this._clearDataBeforeSearch();

      this.getTypeTexts();
    },

    // クライアントの所属学校データを取得
    // 取得したデータを検索用のプルダウンとして表示する
    async getClientSchools() {
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/reserve/get/clientSchools',
          params: {
            to_user_id: this.user.id,
            counseling_type: 2, // テキスト健康相談
          },
        });
        this.clientSchools = response.data.clientSchools;
      } catch (error) {
        alert('クライアントの所属学校データの取得に失敗しました。');
        console.error(error);
      }
    },

    _clearDataBeforeSearch() {
      this.flag.loaders = { progress: true, draft: true, answered: true };
      this.pageMax = 1;
      this.page = 1;
      this.$store.commit('user/counseling/clearCounselorDatas'); // ストアのカウンセラー用データをクリア
      this.$router.replace(`/counselor/?tab=text&page=${this.page}`);
    },

    isOnlyWatchedUser() {
      // チェックボックスで表現する検索条件
      return this.activeTypeItems.find((item) => item.name === 'isWatched' && item.checked) ? 1 : 0;
    },
    isOnlyMyClient() {
      // チェックボックスで表現する検索条件
      return this.activeTypeItems.find((item) => item.name === 'onlyMyClient' && item.checked) ? 1 : 0;
    },
    // isOnlyLatestByUser() {
    //   // チェックボックスで表現する検索条件
    //   return this.activeTypeItems.find((item) => item.name === 'onlyLatestByUser' && item.checked) ? 1 : 0;
    // },

    // ２週間アラートデータが更新された後の処理
    afterUpdateUserWatchData() {
      this.getTypeTexts(); // 表示データを更新する
    },

    // 自分が最終相談者になっている２週間アラート相談者データを取得
    async getMyWatchedClients() {
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/userWatch/get/myClients',
          params: {
            counselor_id: this.user.id,
          },
        });
        this.myWatchedClients = response.data.data;
      } catch (error) {
        alert('自分のクライアントデータの取得に失敗しました。');
        console.error(error);
      }
    },
    isMyCustomer(userId) {
      return !!this.myWatchedClients.find((u) => u.user_id === userId);
    },
  },
};
</script>

<style lang="scss" module>
.wordsearch {
  display: flex;
  align-items: center;
  &_form {
    flex: 1;
  }
  &_btn {
    background-color: var(--orange-main);
    color: #fff;
    margin-left: 10px;
    padding: 15px 30px;
    border-radius: 30px;
    font-weight: bold;
    cursor: pointer;
  }
}
.textarea {
  width: 100%;
  resize: vertical;
  border: none;
  outline: none;
  background-color: var(--gray-sub);
  border-radius: 8px;
  padding: 1em;
  line-height: 1.8;
}
.count {
  display: flex;
  justify-content: flex-end;
  // font-size: 14px;
}
.open {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--gray-side);
  .icon {
    margin-left: 8px;
  }
  @include sm-view {
    justify-content: center;
  }
}
.answer {
  // font-size: 14px;
  padding: 12px;
  background-color: rgba(var(--orange-main-rgb), .15);
  border-radius: 4px;
}
.message {
  color: red;
  font-size: 12px;
  margin-bottom: 1rem;
}

.select {
  display: flex;
  dl {
    display: flex;
    align-items: center;
    margin: 0;
  }
  dt {
    min-width: 6em !important;
    i {
      margin-right: .5em;
    }
  }
  dd {
    width: 65%;
    display: flex;
    align-items: center;
    margin-left: 1em;
  }
  @include sm-view {
    dl {
      display: block;
      margin: 1em 0 .4em;
    }
    dt {
      font-size: 14px;
    }
    dd {
      margin: 0;
    }
  }
  &_box {
    width: 300px;
    padding: 13px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    border-radius: 8px;
    appearance: none;

    &_wrap {
      display: flex;

      li {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
  li {
    // 2つ目以降のチェックボックスにmargin-leftをつける
    &:not(:first-child) {
      margin-left: 1rem;
    }
  }
}
.user_watch {
  display: flex;
  .label_box {
    display: flex;
    width: 100px;
    margin-right: 20px;
      align-items: center;
      justify-content: center;
    @include sm-view {
      width: 100%;
      margin-bottom: 8px;
    }
    &_wide {
      width: 180px;
      @include sm-view {
        width: 100%;
        margin-bottom: 8px;
      }
    }
    &_narrow {
      width: 100px;
      min-width: 100px;
      @include sm-view {
        width: 80px;
        min-width: 80px;
        margin-bottom: 0px;
      }
    }
  }
}
</style>
